export * from '@primeuix/themes/nora/password';
export { default } from '@primeuix/themes/nora/password';
